"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertValue = void 0;
const assert_1 = __importDefault(require("assert"));
/**
 * Asserts that a value is not null or undefined and returns it
 * @param value
 * @param message
 */
const assertValue = (value, message) => {
    (0, assert_1.default)(value !== null && value !== undefined, message);
    return value;
};
exports.assertValue = assertValue;
